import { render } from "./MenuOptionsProjet.vue?vue&type=template&id=3616e25e&scoped=true"
import script from "./MenuOptionsProjet.vue?vue&type=script&lang=ts"
export * from "./MenuOptionsProjet.vue?vue&type=script&lang=ts"

import "./MenuOptionsProjet.vue?vue&type=style&index=0&id=3616e25e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3616e25e"

export default script